import { IconButton, Tooltip, useTheme } from '@mui/material';
import { Edit2 } from 'iconsax-react';
import type { ReactElement } from 'react';

import { hasValue } from '@core/utils/equality';

import { ArchiveIconButton } from '../../Archive/ArchiveIconButton';

type Props<TRow> = {
  row: TRow;
  onEditPress?: (row: TRow) => void;
  onArchivePress?: (row: TRow) => void;
  isRowArchived?: (row: TRow) => boolean;
  /** When false, archive/restore is hidden. @default true */
  canArchive?: boolean;
};

export const RowActions = <TRow,>({
  row,
  onEditPress,
  onArchivePress,
  isRowArchived,
  canArchive = true,
}: Props<TRow>): ReactElement => {
  const theme = useTheme();

  const isArchived = isRowArchived?.(row) ?? false;

  return (
    <>
      {hasValue(onEditPress) && (
        <Tooltip title='Edit'>
          <IconButton onClick={(): void => onEditPress(row)}>
            <Edit2 variant='TwoTone' color={theme.palette.SlabIndigo[700]} />
          </IconButton>
        </Tooltip>
      )}
      {hasValue(onArchivePress) && canArchive && (
        <ArchiveIconButton isArchived={isArchived} onClick={(): void => onArchivePress(row)} />
      )}
    </>
  );
};
